import { AuditAuthor } from "./IAuditAuthor";

export enum FeedbackSource {
  ReportLine = 1,
  ResultsFeedback = 2,
  NotifyNoResults = 3,
  NotifyFewResults = 4,
  RealTimeReport = 5
}

export enum FeedbackStatus {
  New = 0,
  Reviewed = 1,
  Actioned = 2
}

export interface ICustomerFeedback extends AuditAuthor {
  id: number;
  source: FeedbackSource;
  status: FeedbackStatus;
  routeOrigin: string;
  routeDestination: string;
  searchDate: string | null;
  resultsCount: number | null;
  reasons: string[];
  message: string | null;
  tripId: number | null;
  operatorName: string | null;
  tripDepartureTime: string | null;
  tripArrivalTime: string | null;
  lineType: string | null;
  email: string | null;
  fromLocationId: number | null;
  fromStationId: number | null;
  toLocationId: number | null;
  toStationId: number | null;
}
export interface IUpdateFeedbackStatus {
  status: FeedbackStatus;
}
export interface ISourceStatusCount {
  source: FeedbackSource;
  status: FeedbackStatus;
  count: number;
}

export interface IRouteCount {
  origin: string;
  destination: string;
  count: number;
}

export interface IReasonCount {
  reason: string;
  count: number;
}

export interface IFeedbackStats {
  countsBySourceStatus: ISourceStatusCount[];
  topRequestedRoutes: IRouteCount[];
  topAbandonReasons: IReasonCount[];
  totalNew: number;
  totalReviewed: number;
  totalActioned: number;
}
